export function setMetaTitle(title: string): void {
    if (typeof document === 'undefined') {
        return;
    }

    document.title = title;
}
